module.exports = __webpack_public_path__ + "static/media/logo-mdpp.1359e1e1.svg";